import Navbar from './components/Navbar/Navbar'
import About from './components/About/About'
import Image from './components/Image/Image'
import SCWidget from './components/SCWidget/SCWidget'
import Footer from './components/Footer/Footer'


function App() {
  return (
    <div>
      <div className='fondo'></div>
      <Navbar />

      <About />

      <Image />

      <SCWidget />

      <Footer />
    </div>
  );
}

export default App;
